// extracted by mini-css-extract-plugin
export default {"orDivider":"OrDivider--orDivider--ZN0gl","or":"OrDivider--or--xyWvZ","light":"OrDivider--light--4ujn9","line":"OrDivider--line--b1lHF"};